import React from "react";

const AcceptationPrint = ({
  dataEntite,
  datasAuditeur,
  associe_responsable,
  second_associer,
  showIndex = false, // ✅ Nouvelle prop pour activer la numérotation
}) => {
  const tableStyle = {
    borderCollapse: "collapse",
    width: "100%",
    pageBreakInside: "auto", // ✅ Permet au tableau d'être coupé si nécessaire
  };

  const thStyle = {
    border: "1px solid #000000",
    textAlign: "left",
    padding: "5px",
  };

  const tdStyle = {
    border: "1px solid #000000",
    textAlign: "left",
    padding: "5px",
  };

  // ✅ Style pour éviter les sauts de page entre titre et tableau
  const sectionStyle = {
    pageBreakInside: "avoid",
    orphans: 2,
    widows: 2,
  };

  // ✅ Style pour forcer le titre et tableau à rester ensemble si possible
  const titleTableGroupStyle = {
    pageBreakInside: "avoid",
    breakInside: "avoid",
  };

  return (
    <>
      <div>
        <div className="card px-0">
          {/* ✅ Section EB1.1 avec contrôle des sauts de page */}
          <div className="my-10" style={sectionStyle}>
            <div style={titleTableGroupStyle}>
              <h2
                className="fw-bolder text-black mb-3 text-center py-5"
                style={{
                  pageBreakAfter: "avoid", // ✅ Évite le saut après le titre
                  marginBottom: "10px",
                }}
              >
                {"EB1. 1: Acceptation Mission - Critère relatifs à l'Entité"}
              </h2>

              {/* ✅ Tableau collé au titre */}
              <table
                className="tablePerso w-100"
                style={{
                  ...tableStyle,
                  pageBreakBefore: "avoid", // ✅ Évite le saut avant le tableau
                  marginTop: "0", // ✅ Supprime l'espace au-dessus
                }}
              >
                <thead>
                  <tr style={thStyle}>
                    {/* ✅ Colonne N° conditionnelle */}
                    {showIndex && (
                      <th
                        className="min-w-30px sorting w-30px text-center"
                        style={{
                          border: "1px solid #7e8299",
                          padding: "8px",
                          fontSize: "12px",
                        }}
                      >
                        N°
                      </th>
                    )}
                    <th
                      className={`min-w-200px sorting ${
                        showIndex ? "w-270px" : "w-300px"
                      }`}
                      style={{
                        border: "1px solid #7e8299",
                        padding: "8px",
                        fontSize: "12px",
                      }}
                    >
                      {
                        "EB1. 1: Acceptation Mission - Critères relatifs à l'Entité"
                      }
                    </th>
                    <th
                      className="min-w-15px text-end pe-5 sorting w-15px"
                      style={{ border: "1px solid #7e8299", padding: "8px" }}
                    >
                      Réponse
                    </th>
                    <th
                      className="min-w-200px text-end pe-5 sorting w-300px"
                      style={{ border: "1px solid #7e8299", padding: "8px" }}
                    >
                      Commentaires
                    </th>
                  </tr>
                </thead>
                <tbody className="fw-bold text-gray-600">
                  {dataEntite &&
                    dataEntite.length > 0 &&
                    dataEntite.map((item, index) => {
                      return (
                        <tr style={tdStyle} key={`${index}`}>
                          {/* ✅ Numérotation par bloc - Entité */}
                          {showIndex && (
                            <td
                              style={{
                                ...tdStyle,
                                fontSize: "10px",
                                textAlign: "center",
                                fontWeight: "bold",
                              }}
                              className="text-center"
                              colSpan={1}
                            >
                              {index + 1}
                            </td>
                          )}
                          <td
                            style={{ ...tdStyle, fontSize: "10px" }}
                            className="text-start"
                            colSpan={1}
                          >
                            {item.libelle}
                          </td>
                          <td
                            style={{ ...tdStyle, fontSize: "10px" }}
                            className="text-start"
                            colSpan={1}
                          >
                            <div className="text-gray-800 fs-11 me-5">
                              {item.isChecked ? "OUI" : "NON"}
                            </div>
                          </td>
                          <td
                            style={{ ...tdStyle, fontSize: "10px" }}
                            className="text-start"
                            colSpan={1}
                          >
                            <div className="text-gray-800 fs-11 me-5">
                              {item.motif}
                            </div>
                          </td>
                        </tr>
                      );
                    })}
                </tbody>
              </table>
            </div>
          </div>

          {/* ✅ Section EB1.2 avec contrôle des sauts de page */}
          <div className="my-10" style={sectionStyle}>
            <div style={titleTableGroupStyle}>
              <h2
                className="fw-bolder text-black mb-3 text-center py-5"
                style={{
                  pageBreakAfter: "avoid", // ✅ Évite le saut après le titre
                  marginBottom: "10px",
                }}
              >
                {"EB1. 2: Acceptation Mission - Critères relatifs à l'Auditeur"}
              </h2>

              {/* ✅ Tableau collé au titre */}
              <table
                className="tablePerso w-100"
                style={{
                  ...tableStyle,
                  pageBreakBefore: "avoid", // ✅ Évite le saut avant le tableau
                  marginTop: "0", // ✅ Supprime l'espace au-dessus
                }}
              >
                <thead>
                  <tr style={thStyle}>
                    {/* ✅ Colonne N° conditionnelle */}
                    {showIndex && (
                      <th
                        className="min-w-30px sorting w-30px text-center"
                        style={{
                          border: "1px solid #7e8299",
                          padding: "8px",
                          fontSize: "12px",
                        }}
                      >
                        N°
                      </th>
                    )}
                    <th
                      className={`min-w-200px sorting ${
                        showIndex ? "w-270px" : "w-300px"
                      }`}
                      style={{
                        border: "1px solid #7e8299",
                        padding: "8px",
                        fontSize: "12px",
                      }}
                    >
                      {
                        "EB1. 2: Acceptation Mission - Critères relatifs à l'Auditeur"
                      }
                    </th>
                    <th
                      className="min-w-15px text-end pe-5 sorting w-15px"
                      style={{ border: "1px solid #7e8299", padding: "8px" }}
                    >
                      Réponse
                    </th>
                    <th
                      className="min-w-200px text-end pe-5 sorting w-300px"
                      style={{ border: "1px solid #7e8299", padding: "8px" }}
                    >
                      Commentaires
                    </th>
                  </tr>
                </thead>
                <tbody className="fw-bold text-gray-600">
                  {datasAuditeur &&
                    datasAuditeur.length > 0 &&
                    datasAuditeur.map((item, index) => {
                      return (
                        <tr style={tdStyle} key={`${index}`}>
                          {/* ✅ Numérotation par bloc - Auditeur */}
                          {showIndex && (
                            <td
                              style={{
                                ...tdStyle,
                                fontSize: "10px",
                                textAlign: "center",
                                fontWeight: "bold",
                              }}
                              className="text-center"
                              colSpan={1}
                            >
                              {index + 1}
                            </td>
                          )}
                          <td
                            style={{ ...tdStyle, fontSize: "10px" }}
                            className="text-start"
                            colSpan={1}
                          >
                            {item.libelle}
                          </td>
                          <td
                            style={{ ...tdStyle, fontSize: "10px" }}
                            className="text-start"
                            colSpan={1}
                          >
                            <div className="text-gray-800 fs-11 me-5">
                              {item.isChecked ? "OUI" : "NON"}
                            </div>
                          </td>
                          <td
                            style={{ ...tdStyle, fontSize: "10px" }}
                            className="text-start"
                            colSpan={1}
                          >
                            <div className="text-gray-800 fs-11 me-5">
                              {item.motif}
                            </div>
                          </td>
                        </tr>
                      );
                    })}
                </tbody>
              </table>
            </div>
          </div>

          {/* ✅ Section EB1.3 avec contrôle des sauts de page */}
          <div className="my-10" style={sectionStyle}>
            <div style={titleTableGroupStyle}>
              <h2
                className="fw-bolder text-black mb-3 text-center py-5"
                style={{
                  pageBreakAfter: "avoid", // ✅ Évite le saut après le titre
                  marginBottom: "10px",
                }}
              >
                {"EB1.3: Mesures de sauvegarde"}
              </h2>

              {/* ✅ Sections mesures collées au titre */}
              {(dataEntite ?? []).some(
                (question) => question.isChecked !== question.defaultResponse
              ) && (
                <div
                  className="mb-5"
                  style={{
                    marginTop: "0", // ✅ Supprime l'espace au-dessus
                    pageBreakBefore: "avoid", // ✅ Évite le saut avant
                  }}
                >
                  <table
                    style={{
                      ...tableStyle,
                      pageBreakBefore: "avoid", // ✅ Évite le saut avant le tableau
                    }}
                  >
                    <thead>
                      <tr
                        style={thStyle}
                        className="fw-bold fs-6 text-gray-800"
                      >
                        {/* ✅ Colonne N° pour mesures de sauvegarde */}
                        {showIndex && (
                          <th
                            style={thStyle}
                            className="text-center min-w-30px w-lg-30px"
                          >
                            N°
                          </th>
                        )}
                        <th
                          style={thStyle}
                          className={`text-center ${
                            showIndex
                              ? "min-w-120px w-lg-170px"
                              : "min-w-150px w-lg-200px"
                          }`}
                        >
                          Critères à prendre en consideration relatifs à
                          l'entite
                        </th>
                        <th
                          style={thStyle}
                          className="text-center min-w-20px w-lg-20px"
                        >
                          Réponse
                        </th>
                        <th
                          style={thStyle}
                          className="text-center min-w-150px w-lg-150px"
                        >
                          Commentaire
                        </th>
                        <th
                          style={thStyle}
                          className="text-center min-w-200px w-lg-250px"
                        >
                          Mesure sauvegarde
                        </th>
                      </tr>
                    </thead>
                    <tbody>
                      {dataEntite &&
                        dataEntite.length > 0 &&
                        dataEntite
                          .filter(
                            (question) =>
                              question.isChecked !== question.defaultResponse
                          )
                          .map((question, filteredIndex) => (
                            <tr style={tdStyle} key={`entite-${filteredIndex}`}>
                              {/* ✅ Numérotation par bloc - Mesures Entité */}
                              {showIndex && (
                                <td
                                  style={{
                                    ...tdStyle,
                                    fontSize: "10px",
                                    textAlign: "center",
                                    fontWeight: "bold",
                                  }}
                                  className="text-center"
                                  colSpan={1}
                                >
                                  {filteredIndex + 1}
                                </td>
                              )}
                              <td
                                style={{ ...tdStyle, fontSize: "10px" }}
                                className="text-start"
                                colSpan={1}
                              >
                                {question.libelle}
                              </td>
                              <td
                                style={{ ...tdStyle, fontSize: "11px" }}
                                colSpan={1}
                              >
                                <div className="text-gray-800 me-5">
                                  {question.isChecked ? "OUI" : "NON"}
                                </div>
                              </td>
                              <td
                                style={{ ...tdStyle, fontSize: "11px" }}
                                colSpan={1}
                              >
                                <div className="text-gray-800 me-5">
                                  {question.motif}
                                </div>
                              </td>
                              <td
                                style={{ ...tdStyle, fontSize: "11px" }}
                                colSpan={1}
                              >
                                <div className="text-gray-800 me-5">
                                  {question.mesure_sauve}
                                </div>
                              </td>
                            </tr>
                          ))}
                    </tbody>
                  </table>
                </div>
              )}

              {(datasAuditeur ?? []).some(
                (question) => question.isChecked !== question.defaultResponse
              ) && (
                <div
                  className="mb-5"
                  style={{
                    marginTop: "0", // ✅ Supprime l'espace au-dessus
                    pageBreakBefore: "avoid", // ✅ Évite le saut avant
                  }}
                >
                  <table
                    style={{
                      ...tableStyle,
                      pageBreakBefore: "avoid", // ✅ Évite le saut avant le tableau
                    }}
                  >
                    <thead>
                      <tr style={thStyle}>
                        {/* ✅ Colonne N° pour mesures de sauvegarde auditeur */}
                        {showIndex && (
                          <th
                            style={thStyle}
                            className="text-center min-w-30px w-lg-30px"
                          >
                            N°
                          </th>
                        )}
                        <th
                          style={thStyle}
                          className={`text-center ${
                            showIndex
                              ? "min-w-120px w-lg-270px"
                              : "min-w-150px w-lg-300px"
                          }`}
                        >
                          Critères à prendre en consideration relatifs à
                          l'auditeur
                        </th>
                        <th
                          style={thStyle}
                          className="text-center min-w-20px w-lg-20px"
                        >
                          Réponse
                        </th>
                        <th
                          style={thStyle}
                          className="text-center min-w-150px w-lg-150px"
                        >
                          Commentaire
                        </th>
                        <th
                          style={thStyle}
                          className="text-center min-w-200px w-lg-250px"
                        >
                          Mesure sauvegarde
                        </th>
                      </tr>
                    </thead>
                    <tbody>
                      {datasAuditeur &&
                        datasAuditeur.length > 0 &&
                        datasAuditeur
                          .filter(
                            (question) =>
                              question.isChecked !== question.defaultResponse
                          )
                          .map((question, filteredIndex) => (
                            <tr
                              style={tdStyle}
                              key={`auditeur-${filteredIndex}`}
                            >
                              {/* ✅ Numérotation par bloc - Mesures Auditeur */}
                              {showIndex && (
                                <td
                                  style={{
                                    ...tdStyle,
                                    fontSize: "10px",
                                    textAlign: "center",
                                    fontWeight: "bold",
                                  }}
                                  className="text-center"
                                  colSpan={1}
                                >
                                  {filteredIndex + 1}
                                </td>
                              )}
                              <td
                                style={{ ...tdStyle, fontSize: "10px" }}
                                className="text-start"
                                colSpan={1}
                              >
                                {question.libelle}
                              </td>
                              <td
                                style={{ ...tdStyle, fontSize: "11px" }}
                                colSpan={1}
                              >
                                <div className="text-gray-800 me-5">
                                  {question.isChecked ? "OUI" : "NON"}
                                </div>
                              </td>
                              <td
                                style={{ ...tdStyle, fontSize: "11px" }}
                                colSpan={1}
                              >
                                <div className="text-gray-800 me-5">
                                  {question.motif}
                                </div>
                              </td>
                              <td
                                style={{ ...tdStyle, fontSize: "11px" }}
                                colSpan={1}
                              >
                                <div className="text-gray-800 me-5">
                                  {question.mesure_sauve}
                                </div>
                              </td>
                            </tr>
                          ))}
                    </tbody>
                  </table>
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export { AcceptationPrint };
